import { loadableReady } from '@loadable/component';

import type { AddDynamicWidgets } from '../../../core/types/AddDynamicWidgets';
import type { GetPlatformData } from '../../../core/types/GetPlatformData';

import { processWidgets } from './processWidgets';

export const hawk = async ({
  getPlatformData,
  addDynamicWidgets,
}: {
  getPlatformData?: GetPlatformData;
  addDynamicWidgets?: AddDynamicWidgets;
  requestedSite?: string;
}): Promise<void> => {
  return loadableReady(
    async () => {
      await processWidgets({
        getPlatformData,
        addDynamicWidgets,
      });
    },
    { namespace: 'hawk' },
  );
};
